import { AcceptMissionStatus, AgeRestrictionType } from '../api/api.g';

interface ReferralEligibility {
  acceptMissionStatus?: AcceptMissionStatus;
  ageRestrictionType?: AgeRestrictionType;
  requiresRelatedMinorSelection?: boolean;
  eligibleRelatedMinors?: readonly unknown[];
}

/** This requirement blocks accepting a referral, but not viewing its mission. */
export const isReferralRelatedMinorRequired = (eligibility?: ReferralEligibility): boolean =>
  eligibility?.acceptMissionStatus === AcceptMissionStatus.UserIneligibleForMission &&
  eligibility.ageRestrictionType === AgeRestrictionType.Minor &&
  eligibility.requiresRelatedMinorSelection === true &&
  !eligibility.eligibleRelatedMinors?.length;
